import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { IdleAssetCondition, IdleAssetDetail } from 'models/asst/IdleAsset';
import { IdleAssetReviewResult } from '../../models/asst/IdleAssetReviewResult';
import { IdleAssetReview } from '../../models/asst/IdleAssetReview';

/**
 * 유휴자산관리 결과 화면 조회
 * @param condition
 */
export const findIdleAssetReviewResult = async (condition?: IdleAssetCondition) => {
  const params = {
    ...condition,
    copCds: '',
  };
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/asst/review-result`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...params }),
  };
  const response: CommonResponse<IdleAssetReviewResult[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetReviewResult[];
};

/**
 * 결과등록(부서) - 저장
 * @param idleAssetDetail
 */
export const saveIdleAssetReviewResult = async (idleAssetDetail?: IdleAssetDetail[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/asst/review-result-dept`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: idleAssetDetail,
  };

  const response: CommonResponse<IdleAssetDetail[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetDetail[];
};

/**
 * 결과확정(부서) 검토완료
 * @param idleAssetReviewResult
 */
export const saveIdleAssetReviewResultEqp = async (
  idleAssetReviewResult?: IdleAssetReviewResult[]
) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/asst/review-result-eqp`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: idleAssetReviewResult,
  };

  const response: CommonResponse<IdleAssetReviewResult[]> = await callApi(request);
  console.log(response);
  if (response.successOrNot === 'N' || response.statusCode === 'FAIL') {
    // data 안에 메시지가 문자열이라면 그대로 Error로 던지기
    throw new Error(String(response.data));
  }
  return response;
};

/**
 * 결과확정
 * @param idleAssetReviewResult
 */
export const saveIdleAssetReviewResultCfm = async (idleAssetReviewResult?: IdleAssetReview[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/asst/review-result-confirm`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: idleAssetReviewResult,
  };

  const response: CommonResponse<IdleAssetReview[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetReview[];
};
